import { Typography, Box } from "@mui/material";
import AvisosLoading from "../Funcionais/AvisosLoading"
import PropTypes from "prop-types";

const PageTitle = ({ caption, subtitle, setAvisoErro, avisoErro, avisoSucesso, setAvisoSucesso, loading, accentStyle }) => {
  return (
    <>
      <Box mt={0} mb={2}>
        <Typography variant="h4" align="center" gutterBottom sx={accentStyle ? {
          fontWeight: 700,
          color: "#1A3865",
          letterSpacing: "0.4px",
        } : {}}>
          {caption}
        </Typography>
        <h3>{subtitle}</h3>
      </Box>
        <AvisosLoading
          setAvisoErro={setAvisoErro}
          avisoErro={avisoErro}
          avisoSucesso={avisoSucesso}
          setAvisoSucesso={setAvisoSucesso}
          loading={loading}
        />
    </>
  );
};

PageTitle.propTypes = {
  caption: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  setAvisoErro: PropTypes.func,
  avisoErro: PropTypes.string,
  avisoSucesso: PropTypes.string,
  setAvisoSucesso: PropTypes.func,
  loading: PropTypes.bool,
  accentStyle: PropTypes.bool,
};

export default PageTitle;
